import { useMemo, useState } from 'react';
import { useAppContext } from '../../context/AppContext';
import { useHunts } from '../../hooks/useHunts';
import styles from './ManageHuntsModal.module.css';

export default function ManageHuntsModal() {
  const { state, dispatch } = useAppContext();
  const { deleteHunt } = useHunts();
  const [deletingId, setDeletingId] = useState(null);

  const photoCounts = useMemo(() => {
    const counts = new Map();
    for (const photo of state.photos) {
      counts.set(photo.huntId, (counts.get(photo.huntId) ?? 0) + 1);
    }
    return counts;
  }, [state.photos]);

  function close() {
    dispatch({ type: 'CLOSE_MODAL' });
  }

  async function handleDelete(hunt) {
    const count = photoCounts.get(hunt.id) ?? 0;
    const warning = `Delete "${hunt.title}" (${count} photo${count !== 1 ? 's' : ''})? This can't be undone.`;
    if (!window.confirm(warning)) return;

    setDeletingId(hunt.id);
    try {
      await deleteHunt(hunt);
    } catch (err) {
      console.error('Delete hunt failed:', err);
      window.alert('Something went wrong deleting that hunt. Try again.');
    } finally {
      setDeletingId(null);
    }
  }

  return (
    <div className={styles.backdrop} onClick={(e) => e.target === e.currentTarget && close()}>
      <div className={styles.panel}>
        <div className={styles.header}>
          <h2 className={styles.title}>Manage Hunts</h2>
          <button className={styles.closeBtn} onClick={close} aria-label="Close">✕</button>
        </div>

        <div className={styles.body}>
          {state.hunts.length === 0 ? (
            <p className={styles.empty}>No hunts yet.</p>
          ) : (
            <div className={styles.list}>
              {state.hunts.map(hunt => (
                <div key={hunt.id} className={styles.row}>
                  <div className={styles.rowInfo}>
                    <span className={styles.rowTitle}>{hunt.title}</span>
                    <span className={styles.rowCount}>
                      {photoCounts.get(hunt.id) ?? 0} photo{(photoCounts.get(hunt.id) ?? 0) !== 1 ? 's' : ''}
                    </span>
                  </div>
                  <button
                    className={styles.deleteBtn}
                    onClick={() => handleDelete(hunt)}
                    disabled={deletingId === hunt.id || state.hunts.length <= 1}
                    title={state.hunts.length <= 1 ? "Can't delete your only hunt" : `Delete ${hunt.title}`}
                    aria-label={`Delete ${hunt.title}`}
                  >
                    {deletingId === hunt.id ? '…' : '🗑'}
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
